/**
 * ============================================================
 * use-mobile.tsx — Hooks de Deteccao de Dispositivo
 * ============================================================
 *
 * Responsabilidade: Detectar se o usuario esta em dispositivo
 *   movel ou tablet via Media Queries e resize events.
 *
 * Retorno:
 *   - useIsMobile(): boolean — true se largura < 768px
 *   - useIsTablet(): boolean — true se largura entre 768px e 1024px
 *
 * Efeitos colaterais: Registra listener de resize/matchMedia
 *   que e removido no unmount do componente.
 *
 * Quando usar: Para renderizacao condicional de layouts
 *   responsivos (sidebar colapsada, menus mobile, etc.).
 * ============================================================
 */

import * as React from "react";

/** Breakpoint para considerar dispositivo movel (< 768px) */
const MOBILE_BREAKPOINT = 768;

/**
 * Detecta se o dispositivo atual e movel (largura < 768px).
 * Usa matchMedia para escutar mudancas reativas de viewport.
 *
 * @returns true se a largura da tela for menor que 768px
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
